import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

import { resetAuthTokenFromUserAction } from "../actions/auth";

import store from "../store";

export default () => {
  return Object.freeze({
    trackUserEvent: async (
      eventName,
      appId,
      customAppId,
      instructionId,
      goalId,
      userId,
      userId2,
      platform,
      appName,
      instructionName,
      otherDetails
    ) => {
      const options = createRequestOptions({
        eventName,
        appId,
        customAppId,
        instructionId,
        goalId,
        userId,
        userId2,
        platform,
        appName,
        instructionName,
        otherDetails,
      });
      const result = await fetch(
        Config.serverUrl + "/AddUserEvent",
        options
      );
      const response = await result.json();

      const action = resetAuthTokenFromUserAction(response);
      store.dispatch(action);

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/events.js